'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_utils_Tauri$OnCloseBehaviour() {
}
export { $c_Lapp_utils_Tauri$OnCloseBehaviour as $c_Lapp_utils_Tauri$OnCloseBehaviour };
$c_Lapp_utils_Tauri$OnCloseBehaviour.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_utils_Tauri$OnCloseBehaviour.prototype.constructor = $c_Lapp_utils_Tauri$OnCloseBehaviour;
/** @constructor */
function $h_Lapp_utils_Tauri$OnCloseBehaviour() {
}
export { $h_Lapp_utils_Tauri$OnCloseBehaviour as $h_Lapp_utils_Tauri$OnCloseBehaviour };
$h_Lapp_utils_Tauri$OnCloseBehaviour.prototype = $c_Lapp_utils_Tauri$OnCloseBehaviour.prototype;
$c_Lapp_utils_Tauri$OnCloseBehaviour.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
//# sourceMappingURL=app.utils.-Tauri$-On-Close-Behaviour.js.map
